import _ from 'lodash';

// alpinejs modules
import Alpine from '../javascripts/f2/alpinejs_modules.js';
window.Alpine = Alpine;

import * as Turbo from '@hotwired/turbo'
Turbo.start()
// Firebase認証
import '../javascripts/f2/firebase_auth.js';
// Firebase Storageと連携したlightbox機能
import '../javascripts/f2/lightbox_firebase.js';
// TurboJS拡張
import { turboVisit, turboPut, turboPost, turboDelete } from '../javascripts/f2/turbo_fetch.js';
window.turboVisit = turboVisit;
window.turboPut = turboPut;
window.turboPost = turboPost;
window.turboDelete = turboDelete;
window._ = _;

// リップルエフェクト
import '../javascripts/f2/ripple_effect.js';
// select-overlay daisyuiのDropDownが開いた際に他の要素をくりっくできてしまう問題への対応
import '../javascripts/f2/select-overlay.js';

// Google Ad Manager 広告表示制御
import '../javascripts/f2/google_ad_manager.js';

import { convertUtcToLocalText, convertLocalTextToUtc } from '../javascripts/f2/timezone.js';
window.convertUtcToLocalText = convertUtcToLocalText;
window.convertLocalTextToUtc = convertLocalTextToUtc;

document.addEventListener("turbo:before-stream-render", (event) => {
  Alpine.initTree(event.target);
});

Alpine.start();

